import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useGlobalLoaderStore = defineStore('globalLoader', () => {
  const loading = ref<boolean>(false);
  const showLoader = () => {
    loading.value = true;
  };
  const hideLoader = () => {
    loading.value = false;
  };

  return {
    loading,
    showLoader,
    hideLoader,
  };
});
